import React from "react";
import { connect } from "react-redux";
import { setSessionVar } from "../../store/actions";
import ReactPlayer from "react-player/file";

class ImageViewBox extends React.Component {
  componentDidMount() {
    this.props.hideImageViewBox();
  }

  render() {
    if (!this.props.display) return <></>;

    return (
      <div
        className={"image-view-box"}
        onClick={() => this.props.hideImageViewBox()}
      >
        {this.props.src.includes(".mp4") ? (
          <div>
            <ReactPlayer
              height={this.props.height || "70vh"}
              width={this.props.width}
              url={this.props.src}
              controls={true}
            />
          </div>
        ) : (
          <img
            alt={"Media failed to load."}
            src={this.props.src}
            onClick={() => {}}
            height={this.props.height}
            width={this.props.width}
          />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  src: state.session.vars.imageViewBoxSrc,
  display: state.session.vars.showImageViewBox,
});

const mapDispatchToProps = (dispatch) => ({
  hideImageViewBox: () => dispatch(setSessionVar("showImageViewBox", false)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImageViewBox);
